import { Seo } from "../lib/seo";
import { SITE } from "../data/site";
import { PageHero } from "../components/Shared";
import { Reveal } from "../components/Reveal";

export default function MentionsLegales() {
    return (
        <>
            <Seo
                title="Mentions légales | Solino Pro"
                description="Mentions légales du site solinopro.fr — Solino Pro, artisan peinture & revêtement de sol à Chaumont-en-Vexin (60240)."
                path="/mentions-legales"
            />
            <PageHero img="https://images.unsplash.com/photo-1589010243150-58666d535521?q=80&w=1800&auto=format&fit=crop" crumb="Informations" title="Mentions" serif="légales." />
            <section className="mx-auto max-w-[820px] px-5 sm:px-8 py-20 text-sm text-smoke leading-relaxed space-y-10" data-testid="mentions-content">
                <Reveal>
                    <div>
                        <h2 className="text-xl text-ivory mb-4">Éditeur du site</h2>
                        <p>
                            Solino Pro — entreprise individuelle. Siège : 12 Rue Brachedal,
                            60240 {SITE.city} ({SITE.dept}).
                            {" "}{SITE.siret}. {SITE.decennale}.
                        </p>
                        <p className="mt-3">
                            Contact : <a href={`mailto:${SITE.email}`} className="text-gold hover:underline">{SITE.email}</a> —{" "}
                            <a href={SITE.phoneHref} className="text-gold hover:underline">{SITE.phoneDisplay}</a>
                        </p>
                        <p className="mt-3 text-xs">Responsable de la publication : le gérant de Solino Pro.</p>
                        <p className="mt-3">
                            Retrouvez-nous sur Instagram :{" "}
                            <a href="https://instagram.com/solinopro" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline" data-testid="mentions-instagram">
                                instagram.com/solinopro
                            </a>
                        </p>
                    </div>
                </Reveal>
                <Reveal delay={0.05}>
                    <div>
                        <h2 className="text-xl text-ivory mb-4">Hébergement</h2>
                        <p>Hébergeur du site : à compléter (nom, adresse, téléphone de l'hébergeur une fois le domaine solinopro.fr relié).</p>
                    </div>
                </Reveal>
                <Reveal delay={0.1}>
                    <div>
                        <h2 className="text-xl text-ivory mb-4">Données personnelles</h2>
                        <p>
                            Les informations transmises via le formulaire de devis (nom, email, téléphone,
                            ville, photos) servent exclusivement à établir votre devis et vous recontacter.
                            Elles ne sont jamais vendues ni transmises à des tiers. Vous pouvez demander
                            leur suppression à tout moment par email à {SITE.email}.
                        </p>
                    </div>
                </Reveal>
                <Reveal delay={0.15}>
                    <div>
                        <h2 className="text-xl text-ivory mb-4">Propriété & crédits</h2>
                        <p>
                            L'ensemble du contenu de ce site (textes, structure, logo) est la propriété de
                            Solino Pro. Photographies de démonstration : banques d'images libres de droits
                            (Unsplash, Pexels) — à remplacer par les photos de chantier réelles.
                        </p>
                    </div>
                </Reveal>
            </section>
        </>
    );
}
